module.exports = __webpack_public_path__ + "img/bg-login-nb.5feb10fb.png";